window.StickyStacker = (function () {

    var stickyStackerInternal =
    {
        state: {},

        start: function (observableSelectors) {
            if (typeof observableSelectors === 'undefined'
                || observableSelectors === null
                || observableSelectors.length === 0) {
                return;
            }

            if (!Array.isArray(observableSelectors)) {
                return;
            }

            //disconnect existing observer if somebody calls init twice
            if (Object.prototype.toString.call(this.state.observer) === '[object ResizeObserver]') {
                this.state.observer.disconnect();
            }

            //only want unique elements, in case some selectors produce overlapping results, otherwise height would be duplicated
            var elementsArray = new Array();
            observableSelectors.forEach(function (selector) {
                try {
                    var elements = document.querySelectorAll(String(selector));
                    var topSeparation = 0;

                    for (var i = 0; i < elements.length; i++) {
                        if (!elementsArray.includes(elements[i])) {
                            this.updateElementSeparation(elements[i], topSeparation);
                            elementsArray.push(elements[i]);

                            topSeparation += elements[i].offsetHeight;
                        }
                    }
                } catch (err) { } //don't care if it's not a valid selector
            }, this);

            //selectors produced no results, we can just return
            if (elementsArray.size === 0) {
                return;
            }

            this.state = {
                originalSelectors: observableSelectors,
                observer: new ResizeObserver(this.dimensionsChanged),
                observedElements: elementsArray,
                isStarted = true
            };

            this.state.observedElements.forEach(function (observedElement) {
                this.state.observer.observe(observedElement);
            }, this);
        },

        stop: function () {
            if (Object.prototype.toString.call(this.state.observer) === '[object ResizeObserver]') {
                this.state.observer.disconnect();
            }

            this.state = {};
        },

        restart: function () {
            if (this.state.isStarted) {
                var originalSelectors = this.state.originalSelectors;

                this.stop();
                this.start(originalSelectors);
            }
        },

        dimensionsChanged: function () {
            //start from zero in case the topmost sticky also has added separation
            for (var i = 0; i < this.state.observedElements.length; i++) {
                var topSeparation = 0;

                for (var j = i - 1; j >= 0; j--) {
                    topSeparation += this.state.observedElements[j].offsetHeight;
                }

                this.updateElementSeparation(this.state.observedElements[i], topSeparation);
            }
        },

        updateElementSeparation: function (element, separation) {
            var actualSeparation = separation;

            if (element.dataset.stickySeparation !== undefined) {
                actualSeparation += parseInt(element.dataset.stickySeparation);
            }

            element.style.top = actualSeparation + "px";
        }
    };

    stickyStackerInternal.dimensionsChanged = stickyStackerInternal.dimensionsChanged.bind(stickyStackerInternal);
    stickyStackerInternal.updateElementSeparation = stickyStackerInternal.updateElementSeparation.bind(stickyStackerInternal);

    return stickyStackerInternal;

})();
